import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import BaseMixer from "../../../BaseMixer";
import Loader from "@/components/widgets/loader.vue";
import { PAReviewModule } from "@/store/modules/paReview.module";
let ClientEmailBodyTemplate = /** @class */ (() => {
    let ClientEmailBodyTemplate = class ClientEmailBodyTemplate extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.templateValue = `The following reviews need to be completed for the "${this.cycleName}".`;
        }
        get cycleName() {
            return PAReviewModule.clientInteractionDetails?.cycleName;
        }
        customizedText() {
            this.clientManager.templateContent = this.templateValue;
        }
        created() {
            this.clientManager.templateContent = this.templateValue;
        }
        defaultTemplateChanged(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.clientManager.isDeFaultTemplateChanged = true;
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], ClientEmailBodyTemplate.prototype, "clientManager", void 0);
    __decorate([
        Watch("templateValue"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], ClientEmailBodyTemplate.prototype, "defaultTemplateChanged", null);
    ClientEmailBodyTemplate = __decorate([
        Component({
            name: "ClientEmailBodyTemplate",
            components: {
                Loader,
            },
        })
    ], ClientEmailBodyTemplate);
    return ClientEmailBodyTemplate;
})();
export default ClientEmailBodyTemplate;
